import * as React from 'react';

import { BloodworkEntryContainer } from './containers/bloodwork-entry-container';

import { Route } from 'react-router-dom';
import { Home } from './Home';
import { ClientEntryContainer } from './containers/client-entry-container';
import { BloodworkAnalysisContainer } from './containers/bloodwork-analysis-container';
import { BloodworkAnalysisPDFContainer } from './containers/bloodwork-analysis-pdf';
import { ClientAddContainer } from './containers/client-add-container';
import { LogoUploadContainer } from './containers/logo-upload-container';

export class AppRoutes extends React.Component<{}, {}> {
  render() {
    return (
      <div>
        <Route exact path="/" component={Home} />
        <Route exact path="/client/add" component={ClientAddContainer} />
        <Route
          exact
          path="/client/edit/manage"
          component={ClientEntryContainer}
        />
        <Route
          exact
          path="/bloodwork/edit"
          component={BloodworkEntryContainer}
        />
        <Route
          exact
          path="/bloodwork/add"
          component={BloodworkEntryContainer}
        />
        <Route
          exact
          path="/bloodwork/edit/:clientId"
          component={BloodworkEntryContainer}
        />
        <Route
          exact
          path="/bloodwork/analyze"
          component={BloodworkAnalysisContainer}
        />
        <Route
          exact
          path="/bloodwork/analyze/pdf"
          component={BloodworkAnalysisPDFContainer}
        />
        <Route exact path="/logo/upload" component={LogoUploadContainer} />
      </div>
    );
  }
}
